
<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Remover empreendimento"
      message="Você tem certeza que deseja deletar esse empreendimento?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="properties"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhum empreendimento encontrado"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Empreendimentos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-if="isAdmin" color="green" dark class="mb-2 ml-2" v-on:click="exportExcel">
                  Exportar
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Novo Empreendimento
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="property.name"
                            :rules="obrigatoryRule"
                            label="Nome"
                            maxlength="100"
                            required
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="property.unit_value"
                            :rules="obrigatoryRule"
                            label="Custo Unitário"
                            required
                            type="number"
                            min="0"
                            prefix="R$"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                          :items="[{ id: 1, name: 'Condomínio' }, { id: 2, name: 'Bairro' }]"
                          item-text="name"
                          item-value="id"
                          no-data-text="Sem dados"
                          label="Tipo"
                          :rules="obrigatoryRule"
                          v-model="property.type_property_id"
                          required
                          />
                      </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue" :disabled="!valid" text @click="validate">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="edit(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            small
            @click="openConfirmModal(item)"
          >
            mdi-delete-empty
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
    </v-card>
  </div>
</template>

<script>
import xlsx from 'json-as-xlsx'
import moment from 'moment'
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import api from '@/services/api'
import store from '@/store'
import message from '@/utils/message'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    confirmModal: false,
    hasSure: false,
    itemToDelete: null,
    dialog: false,
    loading: true,
    loadingMessage: 'Carregando',
    valid: true,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    obrigatoryRule: [
      v => !!v || 'Informação obrigatória'
    ],
    headers: [
      { text: 'Nome', align: 'start', value: 'name' },
      { text: 'Custo Unitário', value: 'unit_value' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    properties: [],
    realEstateItems: [],
    editedIndex: -1,
    editedId: false,
    property: {
      id: null,
      name: null,
      type_property_id: null,
      unit_value: null
    },
    defaultItem: {
      id: null,
      name: null,
      type_property_id: null,
      unit_value: null
    }
  }),

  computed: {
    modeCreate () {
      return this.editedIndex === -1
    },

    formTitle () {
      return this.editedIndex === -1 ? 'Novo Empreendimento' : 'Editar Empreendimento'
    },

    isAdmin () {
      return store.getters.user.userType !== null && store.getters.user.userType.id === 1
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.getProperties()
    this.getRealEstates()
  },

  methods: {
    async getRealEstates () {
      try {
        const { data } = await api.get('/real-states?page=-1&itemsPerPage=-1')
        this.realEstateItems = data.data
      } catch (error) {
        message.error('Erro ao buscar imobiliárias')
      } finally {
        this.loading = false
      }
    },

    async getProperties () {
      try {
        const { data } = await api.get('/properties')
        this.properties = data
      } catch (error) {
        message.error('Erro ao buscar empreendimentos')
      } finally {
        this.loading = false
      }

      this.loading = false
    },

    async exportExcel () {
      try {
        message.success('Excel sendo gerado. Em instantes será feito o download automático')
        const { data } = await api.post('/properties/excel', { filters: this.filters })
        const dataExcel = await this.getColumnsExcel()
        dataExcel[0].content = data

        const settings = {
          fileName: 'Empreendimentos',
          extraLength: 3,
          writeOptions: {}
        }

        xlsx(dataExcel, settings)
      } catch (error) {
        console.warn(error)
        message.error('Erro ao gerar excel')
      }
    },

    validate () {
      if (this.$refs.form.validate()) {
        this.save()
      }
    },

    async edit (item) {
      this.loadingMessage = 'Carregando'
      this.loading = true

      this.editItemToTable(item)
      this.loading = false
    },

    editItemToTable (item) {
      this.editedIndex = this.properties.indexOf(item)
      this.editedId = item.id
      this.property = Object.assign({}, item)
      this.dialog = true
    },

    async deleteItem () {
      if (this.hasSure) {
        this.loadingMessage = 'Removendo'
        this.loading = true

        try {
          await api.delete(`/properties/${this.itemToDelete.id}`)
          message.success('Empreendimento removido')
          this.removeToTable(this.itemToDelete)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    openConfirmModal (item) {
      this.itemToDelete = item
      this.confirmModal = true
    },

    handleCancelConfirmModal () {
      this.hasSure = false
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.hasSure = true
      this.confirmModal = false
      this.deleteItem()
    },

    removeToTable (item) {
      const index = this.properties.indexOf(item)
      this.properties.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.property = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async save () {
      let data = {
        name: this.property.name,
        type_property_id: this.property.type_property_id,
        unit_value: this.property.unit_value
      }

      this.loading = true

      if (this.editedIndex === -1) {
        this.loadingMessage = 'Salvando'

        try {
          const response = await api.post('/properties', data)
          message.success('Empreendimento salvo')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      } else {
        this.loadingMessage = 'Atualizando'

        try {
          const response = await api.put(`/properties/${this.editedId}`, data)
          message.success('Empreendimento atualizado')
          this.addToTable(response.data)
        } catch (error) {
          message.error(error.message)
        } finally {
          this.loading = false
        }
      }
    },

    addToTable (item) {
      if (this.editedIndex > -1) {
        Object.assign(this.properties[this.editedIndex], this.property)
      } else {
        this.properties.push(item)
      }
      this.close()
    },

    async getColumnsExcel () {
      const data = [
        {
          sheet: 'Lista',
          columns: [
            { label: 'Data de Criação', value: row => row.created_at ? moment(row.created_at).format('DD/MM/YYYY HH:mm') : '' },
            { label: 'Nome', value: 'name' },
            { label: 'Tipo', value: row => row.typeProperty ? row.typeProperty.name : '' },
            { label: 'Custo Unitário', value: 'unit_value' }
          ]
        }
      ]

      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/properties/Properties.vue